import { Store, StoreAttributes } from 'app/model';
import { RestfulApiService } from 'app/services';
import { ModelPrepped, ModelWithoutId } from 'app/type';

class AttributeService extends RestfulApiService<StoreAttributes, Store> {
    protected getFormName(): string {
        return 'store_attribute';
    }

    protected getPath(parent: Store | undefined): string {
        if (!parent) {
            throw new Error('Parent store is required in AttributeService');
        }

        return `stores/${parent.id}/attrs`;
    }

    protected prepareSaveData(entity: ModelWithoutId<StoreAttributes>): ModelPrepped<StoreAttributes> {
        return {
            ...entity,
            clientId: undefined,
            dateCreated: undefined,
            dateEdited: undefined,
            userCreated: undefined,
            userEdited: undefined,
        };
    }
}

export const storeAttributeService = new AttributeService();
